// import external dependencies
import 'jquery';
import 'slick-carousel';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';

// Make PhotoSwipe classes available globally
window.PhotoSwipe = PhotoSwipe;
window.PhotoSwipeLightbox = PhotoSwipeLightbox;

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import about from './routes/about';
//import templateService from './routes/service';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  about,
  //templateService,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
